import { toast } from "../hooks/use-toast";

type NotifyOptions = {
  title?: string;
  description?: string;
};

export function notifySuccess(message: string, options: NotifyOptions = {}) {
  toast({
    title: options.title || "Sucesso",
    description: options.description || message,
  });
}

export function notifyInfo(message: string, options: NotifyOptions = {}) {
  toast({
    title: options.title || "Informação",
    description: options.description || message,
  });
}

export function notifyError(message: string, options: NotifyOptions = {}) {
  toast({
    title: options.title || "Erro",
    description: options.description || message,
  });
}
